import { render, staticRenderFns } from "./Ccp.vue?vue&type=template&id=4cb961cc&scoped=true&"
import script from "./Ccp.vue?vue&type=script&lang=js&"
export * from "./Ccp.vue?vue&type=script&lang=js&"
import style0 from "./Ccp.vue?vue&type=style&index=0&id=4cb961cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb961cc",
  null
  
)

export default component.exports